import React from 'react';

const Location = () => {
	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M16 16.9993C18.2091 16.9993 20 15.2084 20 12.9993C20 10.7901 18.2091 8.99927 16 8.99927C13.7909 8.99927 12 10.7901 12 12.9993C12 15.2084 13.7909 16.9993 16 16.9993Z'
				stroke='white'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M26 12.9993C26 21.9993 16 28.9993 16 28.9993C16 28.9993 6 21.9993 6 12.9993C6 10.3471 7.05357 7.80356 8.92893 5.9282C10.8043 4.05284 13.3478 2.99927 16 2.99927C18.6522 2.99927 21.1957 4.05284 23.0711 5.9282C24.9464 7.80356 26 10.3471 26 12.9993V12.9993Z'
				stroke='white'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Location;
